import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../useTheme";
import ZenLogoWhite from "../../imgs/ZenLogo_white.svg";
import "./Header_Home.css";

const HeaderHome = ({ data, activePage } : { data: any, activePage: string | null }) => {

    const [cookies, setCookie] = useCookies();
    const [theme, toggleTheme] = useTheme();
    const navigate = useNavigate();
    const en = cookies?.language === "en";

    // The nav collapses into a panel below the bar on small screens.
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const loggedIn = data?.userData != null;

    const links = [
        { to: "/", page: "home", ro: "Acasă", en: "Home" },
        { to: "/about-us", page: "about-us", ro: "Despre noi", en: "About us" },
        { to: "/contact", page: "contact", ro: "Contact", en: "Contact" },
    ];

    // A menu left open while the window grows would linger over the page.
    useEffect(() => {
        const onResize = () => { if (window.innerWidth > 900) setMenuOpen(false); };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const actions = (
        <>
            <button
                type="button"
                className="hh-icon-btn"
                title={en ? "Schimbă în română" : "Switch to English"}
                onClick={() => setCookie("language", en ? "ro" : "en")}
            >
                {en ? "RO" : "EN"}
            </button>

            <button
                type="button"
                className="hh-icon-btn"
                title={theme === "dark" ? (en ? "Light mode" : "Mod luminos") : (en ? "Dark mode" : "Mod întunecat")}
                aria-label={theme === "dark" ? "Light mode" : "Dark mode"}
                onClick={() => toggleTheme()}
            >
                <FontAwesomeIcon icon={theme === "dark" ? faSun : faMoon} />
            </button>

            <button
                type="button"
                className="hh-cta"
                onClick={() => navigate(loggedIn ? "/categories" : "/login")}
            >
                {loggedIn ? (en ? "App" : "Aplicație") : "Login"}
                <FontAwesomeIcon icon={faArrowRightLong} />
            </button>
        </>
    );

    return (
        <header className={`home-header${menuOpen ? " open" : ""}`}>
            <div className="hh-bar">
                <a className="hh-brand" href="/">
                    <img src={ZenLogoWhite} alt="ZenVolt" width={34} height={34} />
                    <span>ZenVolt</span>
                </a>

                <nav className="hh-nav">
                    {links.map((l) => (
                        <a
                            key={l.to}
                            href={l.to}
                            className={`hh-link${activePage === l.page ? " current" : ""}`}
                            aria-current={activePage === l.page ? "page" : undefined}
                        >
                            {en ? l.en : l.ro}
                        </a>
                    ))}
                </nav>

                <div className="hh-actions">{actions}</div>

                <button
                    type="button"
                    className="hh-burger"
                    aria-label={en ? "Menu" : "Meniu"}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen(curr => !curr)}
                >
                    <span /><span /><span />
                </button>
            </div>

            {/* Small screens: the same links and actions, dropped below the bar. */}
            <div className="hh-panel">
                <nav className="hh-panel-nav">
                    {links.map((l) => (
                        <a
                            key={l.to}
                            href={l.to}
                            className={`hh-link${activePage === l.page ? " current" : ""}`}
                            aria-current={activePage === l.page ? "page" : undefined}
                        >
                            {en ? l.en : l.ro}
                        </a>
                    ))}
                </nav>
                <div className="hh-panel-actions">{actions}</div>
            </div>
        </header>
    );
};

export default HeaderHome;
